module.exports = "/images/veil-16.jpg";